import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@material-ui/core';
import ExPagination from '../../components/molecules/ExPagination';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      listGochiKid: state.gochis.listGochiKidUse.list,
      totalCount: state.gochis.listGochiKidUse.count,
      offset: state.gochis.listGochiKidUse.offset
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withHandlers({
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    listGochiKid,
    totalCount,
    rowsPerPage,
    page,
    offset,
    handleChangePage,
    selectedPage,
    handleChangeRowsPerPage,
    order,
    orderBy,
    handleRequestSort,
    openUnusedGochiKidModal
  }) => {
    const sortedResult = _.orderBy(listGochiKid, orderBy, order);

    return (
      <div className={classes.root}>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell sortDirection={orderBy === 'usedAt' ? order : false}>
                  <TableSortLabel
                    active={orderBy === 'usedAt'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('usedAt');
                    }}
                  >
                    利用日時
                  </TableSortLabel>
                </TableCell>
                <TableCell sortDirection={orderBy === 'userId' ? order : false}>
                  <TableSortLabel
                    active={orderBy === 'userId'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('userId');
                    }}
                  >
                    ユーザーID
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={orderBy === 'displayName' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'displayName'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('displayName');
                    }}
                  >
                    ユーザー名
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={
                    orderBy === 'gochiKidGroupName' ? order : false
                  }
                >
                  <TableSortLabel
                    active={orderBy === 'gochiKidGroupName'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('gochiKidGroupName');
                    }}
                  >
                    資金グループ名
                  </TableSortLabel>
                </TableCell>
                <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
                  <TableSortLabel
                    active={orderBy === 'shopId'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('shopId');
                    }}
                  >
                    店舗ID
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={orderBy === 'shopName' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'shopName'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('shopName');
                    }}
                  >
                    店舗名
                  </TableSortLabel>
                </TableCell>
                <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
                  <TableSortLabel
                    active={orderBy === 'menuId'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('menuId');
                    }}
                  >
                    メニューID
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sortDirection={orderBy === 'menuName' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'menuName'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('menuName');
                    }}
                  >
                    メニュー名
                  </TableSortLabel>
                </TableCell>
                <TableCell sortDirection={orderBy === 'email' ? order : false}>
                  <TableSortLabel
                    active={orderBy === 'email'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('email');
                    }}
                  >
                    ユーザーメールアドレス
                  </TableSortLabel>
                </TableCell>
                <TableCell>利用されたこどもID</TableCell>
                <TableCell>利用されたこども氏名</TableCell>
                <TableCell
                  sortDirection={orderBy === 'usedAmount' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'usedAmount'}
                    direction={order}
                    onClick={() => {
                      handleRequestSort('usedAmount');
                    }}
                  >
                    利用金額
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedResult &&
                sortedResult.map(gochi => (
                  <TableRow key={gochi.gochiKidUseId}>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          openUnusedGochiKidModal(gochi.gochiKidUseId)
                        }
                      >
                        未使用にする
                      </Button>
                    </TableCell>
                    <TableCell>{gochi.usedAt}</TableCell>
                    <TableCell>{gochi.userId}</TableCell>
                    <TableCell>{gochi.displayName}</TableCell>
                    <TableCell>{gochi.gochiKidGroupName}</TableCell>
                    <TableCell>{gochi.shopId}</TableCell>
                    <TableCell>{gochi.shopName}</TableCell>
                    <TableCell>{gochi.menuId}</TableCell>
                    <TableCell>{gochi.menuName}</TableCell>
                    <TableCell>{gochi.email}</TableCell>
                    <TableCell>
                      {gochi.userKids &&
                        gochi.userKids.length > 0 &&
                        gochi.userKids.map(userKid => (
                          <div key={userKid.userKidId}>{userKid.userKidId}</div>
                        ))}
                    </TableCell>
                    <TableCell>
                      {gochi.userKids &&
                        gochi.userKids.length > 0 &&
                        gochi.userKids.map(userKid => (
                          <div key={userKid.userKidId}>
                            {userKid.displayName}
                          </div>
                        ))}
                    </TableCell>
                    <TableCell>
                      {gochi.usedAmount !== null
                        ? gochi.usedAmount.toLocaleString()
                        : ''}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={listGochiKid}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
